import { useQuery } from "@tanstack/react-query";
import { checkIcon, errorIcon } from "assets/icon/Icon_modal";
import { alertModalConfig } from "components/templates/modalConfig";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { hr_uris_GET } from "../utils/uris/hr_uris";

const useGetQueryhr = (
  name,
  paramValues,
  enabledOption,
  pilotFlag = false,
  refetchOnWindowFocus = false
) => {
  const navigate = useNavigate();

  const [data, setData] = useState();
  const [pageInfo, setPageInfo] = useState({
    total: 0,
    pageNo: 1,
    totalPage: 0,
  });
  const { isLoading, isFetching, isError, refetch } = useQuery(
    [name, paramValues],
    (queryKey) => hr_uris_GET(name, queryKey, pilotFlag),
    {
      retry: 1,
      refetchOnWindowFocus: refetchOnWindowFocus,
      enabled: enabledOption,
      keepPreviousData: true,
      onSuccess: (res) => {
        res.data.data && setData(res.data.data);
        res.data.data &&
          setPageInfo((prev) => ({
            ...prev,
            totalPage: res.data.data?.totalPage,
            total: res.data.data?.total,
            pageNo: res.data.data?.pageNo,
          }));
      },
      onError: (err) => {
        if (err.response.status >= 400) {
          //* 권한오류
          if (
            err.response.data.message === "Unauthorized" ||
            err.response.data.message === "잘못된 토큰입니다."
          ) {
            Swal.fire(
              alertModalConfig({
                text: `유효하지 않은 토큰입니다. \n 다시 로그인 해주세요.`,
                title: "Error",
                iconHtml: errorIcon,
                confirmButtonText: "확인",
              })
            ).then((result) => {
              if (result.isConfirmed) navigate("/login_hr");
            });
          } else {
            Swal.fire(
              alertModalConfig({
                text: err.response.data.message,
                title: "Error",
                iconHtml: errorIcon,
                confirmButtonText: "확인",
              })
            );
          }
        }
      },
    }
  );

  return { data, pageInfo, isFetching, isLoading, isError, refetch };
};

export default useGetQueryhr;
